import { tableActions } from "../../../../actions/ui/table.actions";
import { useAppDispatch } from "../../../../effects/useAppDispatch";
import { useAppSelector } from "../../../../effects/useAppSelector";
import IconSVG from "../../../../styles/svg-icons";

interface Props {
    tableKey: string;
    onReset: () => void;
}

export function ResetTableSortingButton({ tableKey, onReset }: Props) {
    const dispatch = useAppDispatch();
    const sortBy = useAppSelector(s => s.ui.table.sort[tableKey]?.sortBy);

    const handleClick = () => {
        dispatch(tableActions.sortReset(tableKey));
        onReset();
    }

    return (
        <button
            disabled={!sortBy} 
            onClick={handleClick}
            className="btn-link"
        >
            <IconSVG name="undo" width={16} height={16} />
            Undo Sorting
        </button>
    );
}